import React from 'react';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { ReviewsSection } from './components/ReviewsSection';
import { CredentialsSection } from './components/CredentialsSection';
import { ServiceAreaSection } from './components/ServiceAreaSection';
import { ContactSection } from './components/ContactSection';
import { FreeBookCTA } from './components/FreeBookCTA';
import { Footer } from './components/Footer';
import { LenderLogos, AUSSIE_LENDERS } from './components/LenderLogos';
export function App() {
  // Filter for active lenders only for the panel
  const activeLenders = AUSSIE_LENDERS.filter(l => l.active !== false);
  return <div className="min-h-screen bg-background-body font-body text-text-default" data-id="element-0">
      <Header data-id="element-1" />

      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <ReviewsSection data-id="element-4" />
        <CredentialsSection data-id="element-5" />

        <section className="py-16 sm:py-20 bg-background-body" data-id="element-6">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-7">
            <LenderLogos lenders={activeLenders} showTitle={true} columns={6} data-id="element-8" />
          </div>
        </section>

        <ServiceAreaSection data-id="element-9" />
        <ContactSection data-id="element-10" />
        <FreeBookCTA data-id="element-11" />
      </main>

      <Footer data-id="element-12" />
    </div>;
}